import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import styleClasses from "./css/MyPage.module.scss";
import { saveUserLog } from './LogandUtils'; // 경로에 맞게 수정

function PushContact() {
  // URL에서 "contactId" 파라미터를 읽어옴 (예: ?contactId=xxx)
  const [searchParams] = useSearchParams();
  const contactId = searchParams.get("contactId"); 
  const navigate = useNavigate();
  const user = auth.currentUser;

  const [musicards, setMusicards] = useState([]);
  const [selectedMusicard, setSelectedMusicard] = useState("");

  useEffect(() => {
    if (!user) {
      console.error("사용자가 로그인되어 있지 않습니다.");
      navigate("/login");
      return;
    }
    // 사용자의 musicard 필드 중 key에 solo가 포함된 항목만 가져옴
    const fetchMusicards = async () => {
      try {
        const userDocSnap = await getDoc(doc(db, "users", user.uid));
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          const soloMusicardList = Object.entries(userData.musicard || {})
            .filter(([key]) => key.toLowerCase().includes("solo"))
            .map(([key, value]) => ({
              id: key,
              name: value,
            }));
          setMusicards(soloMusicardList);
        } else {
          console.error("사용자 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("뮤지카드 가져오기 오류:", error);
      }
    };
    fetchMusicards();
  }, [user, navigate]);

  const handleSubmit = async () => {
    if (!selectedMusicard || !contactId) {
      alert("뮤지카드와 연락처를 선택해주세요.");
      return;
    }

    try {
      // 1. users_data에서 해당 연락처 데이터를 가져오기
      const userContactRef = doc(db, `users_data/${user.uid}/contact`, contactId);
      const contactSnap = await getDoc(userContactRef);
      if (!contactSnap.exists()) {
        alert(`복사할 연락처 데이터를 찾을 수 없습니다: ${contactId}`);
        return;
      }
      const contactData = contactSnap.data();

      // 2. 연락처의 나머지 정보(email, musicLinks, name)를 personal 문서에 저장
      const personalData = {
        name: contactData.name,
        email: contactData.email,
        introduction: contactData.introduction,
        musicLinks: contactData.musicLinks,
      };
      const musicianPersonalRef = doc(
        db,
        `musicians/${selectedMusicard}/contact`,
        "personal"
      );
      await setDoc(musicianPersonalRef, personalData, { merge: true });
      await saveUserLog('musicard_logs', selectedMusicard, 'create', musicianPersonalRef.path, 'PushAlbum');

      // 3. 연락처의 location 정보를 각각 musicians/{selectedMusicard}/contact/{번호}로 저장  
      // contactData.location는 배열이어야 하며, 각 항목은 { placeName, lat, lng, ... } 형태여야 함
      if (contactData.location && Array.isArray(contactData.location)) {
        const locationObj = {};
        contactData.location.forEach((loc, index) => {
          locationObj[`${index + 1}`] = loc;
        });
        const musicianLocationRef = doc(
          db,
          `musicians/${selectedMusicard}/contact`,
          "location"
        );
        await setDoc(musicianLocationRef, locationObj, { merge: true });
        await saveUserLog('musicard_logs', selectedMusicard, 'create', musicianLocationRef.path, 'PushContact');

      }

      // 4. users_data의 해당 포지션 문서에서 act 필드를 업데이트 (기존 act와 병합)
      await setDoc(userContactRef, {
        act: {
            [selectedMusicard]: contactId
        }
      }, { merge: true });

      alert("뮤지카드에 연락처 정보가 추가되었습니다!");
      navigate("/my-page/contact");
    } catch (error) {
      console.error("연락처 추가 오류:", error);
      alert("연락처 추가 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className={styleClasses.pushPage}>
      <h1>뮤지카드로 연락처 내보내기</h1>
      <p>연락처 정보를 뮤지카드에 내보냅니다.</p>
      <div className={styleClasses.form}>
        <label>내 뮤지카드 선택</label>
        <select
          value={selectedMusicard}
          onChange={(e) => setSelectedMusicard(e.target.value)}
        >
          <option value="">뮤지카드를 선택하세요</option>
          {musicards.map((card) => (
            <option key={card.id} value={card.name}>
              {card.name}
            </option>
          ))}
        </select>
        <button onClick={handleSubmit} className="primaryButton">
          연락처 내보내기
        </button>
      </div>
    </div>
  );
}

export default PushContact;